import { gql } from '@apollo/client'
import kudosFragment from './fragments/kudos.fragment'

export const ARE_KUDOS_VISIBLE_FOR_ME = gql`
  query AreKudosVisibleForMe {
    areKudosVisibleForMe
  }
`

export const GET_KUDOS_RECEIVED_BY_ME = gql`
  query GetKudosReceivedByMe($pagination: KudosPaginationInput!) {
    getKudosReceivedByMe(pagination: $pagination) {
      isKudosEnabled
      employeeOptedOut
      kudosPagination {
        kudos {
          ...Kudos
        }
        totalPages
        currentPage
        totalCount
      }
    }
  }
  ${kudosFragment}
`

export const GET_KUDOS_FOR_EMPLOYEE = gql`
  query GetKudosForEmployee($employeeId: HashedId!, $pagination: KudosPaginationInput!, $employeeResigned: Boolean = false) {
    getKudosForEmployee(employeeId: $employeeId, pagination: $pagination, employeeResigned: $employeeResigned) {
      isKudosEnabled
      employeeOptedOut
      kudosPagination {
        kudos {
          ...Kudos
        }
        totalPages
        currentPage
        totalCount
      }
    }
  }
  ${kudosFragment}
`

export const GET_ATTENTION_POINTS_FOR_EMPLOYEE = gql`
  query GetAttentionPointsForEmployee($employeeId: HashedId!, $pagination: KudosPaginationInput!, $employeeResigned: Boolean = false) {
    getAttentionPointsForEmployee(employeeId: $employeeId, pagination: $pagination, employeeResigned: $employeeResigned) {
      kudos {
        ...Kudos
      }
      totalPages
      currentPage
      totalCount
    }
  }
  ${kudosFragment}
`

export const GET_KUDOS_FOR_EMPLOYEE_IN_APPRAISAL = gql`
  query GetKudosForEmployeeInAppraisal($employeeId: HashedId!, $appraisalInput: KudosAppraisalInput!) {
    getKudosForEmployeeInAppraisal(employeeId: $employeeId, appraisalInput: $appraisalInput) {
      isKudosEnabled
      employeeOptedOut
      kudosPagination {
        kudos {
          ...Kudos
        }
        totalPages
        currentPage
        totalCount
      }
    }
  }
  ${kudosFragment}
`

export const GET_ALL_KUDOS = gql`
  query GetAllKudos($filters: KudosFilterInput!) {
    getAllKudos(filters: $filters) {
      kudos {
        ...Kudos
      }
      hasMore
      nextOffset
    }
  }
  ${kudosFragment}
`

export const GET_ALL_ATTENTION_POINTS = gql`
  query GetAllAttentionPoints($filters: KudosFilterInput!) {
    getAllAttentionPoints(filters: $filters) {
      kudos {
        ...Kudos
      }
      hasMore
      nextOffset
    }
  }
  ${kudosFragment}
`

export const GET_KUDOS_GIVEN_BY_REPLYER = gql`
  query GetKudosGivenByReplyer($filters: KudosByReplyerFilterInput!) {
    getKudosGivenByReplyer(filters: $filters) {
      kudos {
        ...Kudos
      }
      hasMore
      nextOffset
    }
  }
  ${kudosFragment}
`

// ////////
// SETTINGS
// ////////

export const GET_KUDOS_LEGAL_ENTITY_VISIBILITY_DATA = gql`
  query GetKudosLegalEntityVisibilityData($filters: KudosLegalEntityVisibilityFilterInput!) {
    getKudosLegalEntityVisibilityData(filters: $filters) {
      kudosLegalEntityVisibilityList {
        id
        legalEntityId
        legalEntityName
        country
        kudosEnabled
      }
      hasMore
      nextOffset
    }
  }
`

export const GET_KUDOS_COMPANY_COUNTRY_VISIBILITY_DATA = gql`
  query GetKudosCompanyCountryVisibilityData($filters: KudosCompanyCountryVisibilityFilterInput!) {
    getKudosCompanyCountryVisibilityData(filters: $filters) {
      kudosCompanyCountryVisibilityList {
        id
        companyId
        companyName
        country
        kudosEnabled
      }
      hasMore
      nextOffset
    }
  }
`
